import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router'
import { AuthLayout } from 'shared/layout'
import { SpinnerLoader } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ResetPasswordForm } from 'pages/auth/pages/reset/ui/ResetPassword/ui/ResetPasswordForm/ResetPasswordForm'
import { ResetPasswordStore } from 'pages/auth/pages/reset/ui/ResetPassword/store/resetPasswordStore'
import { ExpiredForm } from 'pages/auth/pages/reset/ui/ResetPassword/ui/ExpiredFrom/ExpiredForm.tsx'
import styles from './styles.module.scss'

export const ResetPasswordContent = observer(({ store }: { store: ResetPasswordStore }) => {
  if (store.preloading) {
    return (
      <div className={styles.wrap}>
        <SpinnerLoader ariaLabel={'ResetPassword'} />
      </div>
    )
  }

  if (!store.isValidToken) {
    return <ExpiredForm />
  }

  return (
    <div className={styles.wrap}>
      <AuthLayout
        title={'Create new password'}
        form={<ResetPasswordForm store={store} />}
        formClassnames={styles.successWrap}
      />
    </div>
  )
})

export const ResetPassword = () => {
  const { token } = useParams()
  const entities = useEntitiesContext()
  const store = new ResetPasswordStore(token || '', entities)

  return <ResetPasswordContent store={store} />
}

export default ResetPassword
